// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + {"532":"styles","678":"component---src-pages-index-js","883":"component---src-pages-404-js","987":"component---src-templates-documentation-template-js"}[chunkId] + "-" + {"532":"a72d2d7f2706060a25d5","678":"a41956a348663c41d5a3","883":"ed799b56d797aef78f44","987":"73ce6fa19eee0cb2de54"}[chunkId] + ".js";
};